import { Icon } from "@chakra-ui/react";
import React from "react";

export const TransactionIcon = (props: any) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 12C2.5 6.76214 6.76214 2.5 12 2.5C17.2379 2.5 21.5 6.76214 21.5 12C21.5 17.2379 17.2379 21.5 12 21.5C6.76214 21.5 2.5 17.2379 2.5 12ZM3.5 12C3.5 16.6871 7.31286 20.5 12 20.5C16.6871 20.5 20.5 16.6871 20.5 12C20.5 7.31286 16.6871 3.5 12 3.5C7.31286 3.5 3.5 7.31286 3.5 12Z"
      stroke="currentColor"
    />
    <path
      d="M12 11C10 11 10 10.374 10 10C10 9.51602 10.701 9.00002 12 9.00002C13.185 9.00002 13.386 9.63802 13.4 10.018L14.4 10H15.4C15.4 8.97402 14.734 7.53102 13 7.12102V6.01202H11V7.08502C9.029 7.41602 8 8.71202 8 10C8 11.12 8.52 13 12 13C14 13 14 13.676 14 14C14 14.415 13.38 15 12 15C10.159 15 10.011 14.143 10 14H8C8 14.918 8.661 16.553 11 16.92V18H13V16.915C14.971 16.584 16 15.288 16 14C16 12.88 15.48 11 12 11Z"
      fill="currentColor"
    />
  </Icon>
);
